module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-1-Australia-Landing-Page.ec72820f.jpg";